import { TournamentRankingPage } from "@/pages/tournament/ranking/page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_pathlessLayout/tournament/ranking")({
    component: TournamentRankingPage,
});
